/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { formValue } from "../../../../services/formServiceFunctions";
import ValidatorSelect from "../../../Validator/ValidatorSelect";
import ValidatorNumberField from "../../../Validator/ValidatorNumberField";
import { processCostSupportStyle } from "../../processCostSupportStyle";
import { Person } from "../../../../types/Person";
import { UseForm } from "../../../../types/UseForm";

type AlimonyPersonProps = {
  path: string;
  person: Person;
  handleBlur: UseForm["handleBlur"];
  handleChange: UseForm["handleChange"];
};

const AlimonyPerson = ({ path, person, handleBlur, handleChange  }: AlimonyPersonProps) => {
  return (
    <>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Wie heißt die Person, der Sie Unterhalt zahlen bzw. die bei Ihnen wohnt?
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          name={path + ".givenName"}
          label="Vorname"
          value={formValue(person, "givenName")}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          name={path + ".familyName"}
          label="Nachname"
          value={formValue(person, "familyName")}
          onChange={handleChange}
        />
      </Grid>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Wo wohnt die Person?
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorSelect
          label={"Wohnt bei mir"}
          name={path + ".livesWithPetitioner"}
          value={formValue(person, "livesWithPetitioner")}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <MenuItem value="false">Nein</MenuItem>
          <MenuItem value="true">Ja</MenuItem>
        </ValidatorSelect>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          name={path + ".address.streetAddress"}
          label="Straße und Hausnummer"
          value={formValue(person, "address.streetAddress")}
          onChange={handleChange}
          disabled={person.livesWithPetitioner}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          name={path + ".address.postalCode"}
          label="Postleitzahl"
          value={formValue(person, "address.postalCode")}
          onChange={handleChange}
          disabled={person.livesWithPetitioner}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          name={path + ".address.addressLocality"}
          label="Ort"
          value={formValue(person, "address.addressLocality")}
          onChange={handleChange}
          disabled={person.livesWithPetitioner}
        />
      </Grid>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Wann wurde die Person geboren?
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <TextField
          name={path + ".birthDate"}
          label="Geburtsdatum"
          value={formValue(person, "birthDate")}
          onChange={handleChange}
        />
      </Grid>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Welches Verhältnis haben Sie zu der Person?
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorSelect
          label={"Verhältnis"}
          value={formValue(person, "relation")}
          onChange={handleChange}
          name={path + ".relation"}
          inputProps={{
            name: "relation",
          }}
          MenuProps={{
            slotProps: {
              paper: {
                style: { maxHeight: 200 },
              },
            },
          }}
        >
          <MenuItem value={"Kind"}>Sie ist mein Kind</MenuItem>
          <MenuItem value={"Ehepartner"}>Sie ist mein Ehepartner/Expartner</MenuItem>
          <MenuItem value={"Lebenspartner"}>Sie ist mein Lebenspartner/Expartner</MenuItem>
          <MenuItem value={"Elternteil"}>Sie ist mein Vater/meine Mutter</MenuItem>
        </ValidatorSelect>
      </Grid>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Falls Sie einen monatlichen Geldbetrag bezahlen: Wie viel Unterhalt zahlen Sie pro Monat?
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          name={path + ".alimony"}
          label="Monatlicher Betrag"
          value={formValue(person, "alimony")}
          helperText={"Wenn Sie nichts zahlen, geben Sie einfach '0' an"}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorSelect
          label={"Hat die Person eigene Einnahmen"}
          value={formValue(person, "hasIncome")}
          onChange={handleChange}
          name={path + ".hasIncome"}
          inputProps={{
            name: "hasIncome",
          }}
          helperText={"z.B. Ausbildungsvergütung oder Unterhalt durch den anderen Elternteil"}
          MenuProps={{
            slotProps: {
              paper: {
                sx: { maxHeight: 200 },
              },
            },
          }}
        >
          <MenuItem value={"yes"}>Ja</MenuItem>
          <MenuItem value={"no"}>Nein</MenuItem>
        </ValidatorSelect>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <ValidatorNumberField
          fieldType={"money"}
          numberType={"float"}
          name={path + ".income"}
          label="Monatliche Einnahmen"
          value={formValue(person, "income")}
          onChange={handleChange}
          disabled={person.hasIncome !== "yes"}
        />
      </Grid>
    </>
  );
};
export default AlimonyPerson;
